import React, { useState, useEffect } from "react";
import Alert from "react-bootstrap/Alert";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { Link } from "react-router-dom";

import ContactForm from "~/Components/Elements/Forms/Contact/ContactForm";

import { useUser } from "~/Context/userContext";
import ChimneyProfileContainer from "../Profile/Containers/ChimneyProfileContainer";

const ContactPage = ({ match }) => {
  const messageTo = match.params.chimDir;

  const { state: userState } = useUser();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(!userState.loaded);
  }, [userState.loaded]);

  const [saved, setSaved] = useState(false);
  const [failure, setFailure] = useState(false);
  const onFailure = () => {
    setFailure(true);
  };
  const onSave = () => {
    setSaved(true);
  };
  return (
    <div className="ContactPageWrapper">
      <div className="page-header">
        <h2>Contact</h2>
        <ChimneyProfileContainer
          chimDir={messageTo}
          render={({ profile, loading }) =>
            !loading && (
              <div>
                <p>Send a quick message to {profile.full_name} Chimney</p>
              </div>
            )
          }
        />
        {saved && (
          <Alert variant="success" onClose={() => setSaved(false)} dismissible>
            Your message was sent. Hopefully you will hear back soon.
            <div>
              <Link to={`/profile/${messageTo}`}>Back to profile</Link>
            </div>
          </Alert>
        )}
        {failure && !saved && <Alert variant="danger">There was an error while saving. Check the input and try again.</Alert>}

        {loading && (
          <SkeletonTheme color="#fff" highlightColor="#f3f3f3">
            <Skeleton count={1} />
          </SkeletonTheme>
        )}

        {!loading && !saved && <ContactForm userTo={messageTo} userFrom={userState} onFailure={onFailure} onComplete={onSave} />}
      </div>
    </div>
  );
};

export default ContactPage;
